export default "__VITE_ASSET__2e19f28e__"